<template>
  <div class="box">
    <div class="is-flex">
      <div class="has-text-weight-semibold is-size-5">{{ getDateTime(tableData.date) }}</div>
    </div>

    <table style="width: 100%" class="mt-3">
      <tr class="is-size-7 has-text-weight-light">
        <th>STAGE NAME</th>
        <th>DIRECTION</th>
        <th>USER CLASS</th>
        <th>COUNT</th>
      </tr>
      <template v-for="(stage, stageIndex) in tableData.stages">
        <template v-for="(direction, dirIndex) in stage.directions">
          <template v-for="(data, index) in direction.data">
            <tr :key="index.toString() + dirIndex.toString() + stageIndex.toString()"
                :class="index % 2 === 0 ? 'evenRow' : ''" class="has-text-weight-semibold">
              <td v-if="index === 0 && dirIndex === 0" :rowspan="getRowCountForStage(stage)"
                  class="middle has-text-weight-semibold is-size-5" style="width: 10%">{{ stage.name }}
              </td>
              <td v-if="index === 0" :rowspan="getDirectionsCountForStage(direction)"  class="middle has-text-weight-semibold is-size-6"
                  style="background: #bebebe; width: 10%">{{ direction.name }}
              </td>
              <td style="width: 20%">{{ data.userClass }}</td>
              <td style="width: 15%">{{ data.count }}</td>
            </tr>
          </template>
        </template>
      </template>
    </table>
  </div>
</template>

<script>

export default {
  name: "import-validation-data-table",
  props: {
    validationCount: {
      type: Object
    }
  },
  data() {
    return {}
  },
  mounted() {
    console.log('Table Data: ', this.validationCount)
  },
  methods: {
    onViewVideo(){
      console.log('Open mata data: ', this.metaDataId)
      if(this.metaDataId){
        this.$emit('onOpenVideo', this.metaDataId)
      }

    },
    getDateTime(date) {
      if(date){
        return date.replace('T', ' ')
      }
      return 'Not Set'
    },
    getRowCountForStage(stage) {
      let stageRowsCount = 0
      if (stage && stage.directions && stage.directions.length > 0) {
        stage.directions.forEach(direction => {
          if (direction.data && direction.data.length > 0) {
            stageRowsCount += direction.data.length
          }
        })
      }
      return stageRowsCount
    },
    getDirectionsCountForStage(direction) {
      if (direction && direction.data && direction.data.length > 0) {
        return direction.data.length
      }
      return 0
    },
  },
  computed: {
    metaDataId(){
      if(this.validationCount){
        console.log("Metadata: ", this.validationCount)
        let keys = Object.keys(this.validationCount)
        if(keys && keys.length > 0){
          return this.validationCount[keys[0]].videoMetaDataId
        }
      }
      return null
    },
    tableData() {

      let fakeData = this.validationCount
      console.log('Data: ', fakeData)

      let tableData = {}
      if (fakeData) {
        tableData.date = Object.keys(fakeData)[0]

        tableData.stages = []
        let stageNames = Object.keys(fakeData[tableData.date])
        if (stageNames && stageNames.length > 0) {
          stageNames.forEach(stageName => {
            let stage = {name: stageName, directions: []}
            let directionNames = Object.keys(fakeData[tableData.date][stageName])
            if (directionNames && directionNames.length > 0) {
              directionNames.forEach(dirName => {
                let direction = {
                  name: dirName,
                  data: []
                }

                let userClassNames = Object.keys(fakeData[tableData.date][stageName][dirName])
/*                let aiCount = fakeData[tableData.date][stageName][dirName].ai_count
                let manualCount = fakeData[tableData.date][stageName][dirName].manual*/
                if (userClassNames && userClassNames.length > 0) {

                  for (let i = 0; i < userClassNames.length; i++) {
                    const name = userClassNames[i]
                    let userClass = {
                      userClass: name,
                      count: fakeData[tableData.date][stageName][dirName][name],
                    }
                    direction.data.push(userClass)
                  }
                }


                stage.directions.push(direction)

              })
            }

            tableData.stages.push(stage)
          })
        }
      }


      console.log('Table Data', tableData)
      return tableData

    }
  }
}
</script>

<style scoped lang="scss">
table {
  border: 1px solid #c4c4c4;
  border-collapse: collapse;
  padding: 8px 8px 8px 8px;
}

td {
  border: 1px solid #e5e5e5;
  padding: 4px 8px 4px 8px;
  font-size: 14px;
}

th {
  background: rgba(24, 170, 126, 0.35);
  border: none;
  padding: 8px 8px 8px 8px;
  color: rgba(0, 0, 0, 0.65)
}

.middle {
  text-align: center;
  vertical-align: middle;
  background: #ffffff;
}

.evenRow {
  background: #f1f1f1;
}
</style>